import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import tagService from './tag.service';

import { TagsComponent } from './tags.component';
import { TagsRouter } from './tags.router';

/**
 * @desc Angular migration helper to register tags module and supply downgraded component
 * @constant {angular.module}
 */
const tagsModule = angular
  .module('ec.opsCenter.tags', [])
  .config(TagsRouter)
  .service('tagService', tagService)
  .directive('appTags', downgradeComponent({ component: TagsComponent }) as angular.IDirectiveFactory).name;

export default tagsModule;



// WEBPACK FOOTER //
// ./src/app/tags/tags.module.ajs.ts